<template>
  <div>
    <van-cell-group>
      <van-cell
        title="预约记录"
        is-link
        :value="appoint_record"
        @click="chooseRecord"
      />
      <van-cell
        title="预约记录ID"
        :value="detail.id"
      />
      <van-cell
        title="姓名"
        :value="detail.cname"
      />
      <van-cell
        title="电话"
        :value="detail.telno"
      />
      <van-cell
        title="年龄"
        :value="detail.age"
      />
      <van-cell
        title="性别"
        :value="detail.sex"
      />
      <!-- <van-cell
        title="编号"
        :value="detail."
      /> -->
      <van-cell
        title="医生编号"
        :value="detail.empNo"
      />
      <van-cell
        title="医生姓名"
        :value="detail.doctorName"
      />

      <van-cell
        title="预约类型"
        :value="detail.reType"
      />
      <van-cell
        title="预约日期"
        :value="yy_date"
      />
      <van-cell
        title="预约时间"
        :value="detail.reTime"
      />
      <van-cell
        title="备注"
        :value="detail.remark"
      />
    </van-cell-group>

    <!--预约记录-->
    <van-popup
      v-model="record_show"
      position="bottom"
    >
      <van-picker
        :columns="recordColumns"
        @cancel="record_show = false"
        @confirm="onRecordChange"
        :show-toolbar="true"
      />
    </van-popup>
    <div>诊所基本会按照您预约的时间来安排治疗，但可能会稍微等待，敬请谅解!</div>
    <div
      style="padding: 10px;"
      v-if="detail.cancel != 1"
    >
      <van-button
        type="danger"
        size="large"
        @click="cancelAppoint"
      >取消预约</van-button>
    </div>
    <div
      style="padding: 10px;"
      v-else
    >
      <van-button
        type="default"
        size="large"
      >已取消</van-button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      detail: {},
      detail_id: "",
      yy_date: "",
      baseUrl: "/appoint_details",
      record_show: false,
      appoint_record: "最近一次",
      recordColumns: [],
      records: []
    };
  },
  mounted() {
    let id = this.$route.query.id || localStorage.recent_id || "";

    if (!id) {
      this.$toast("系统没查到您的信息,请先去预约!");
      setTimeout(function() {
        this.$router.push("/");
      }, 1000);
      return;
    }
    this.getAppointRecords(id);
    this.detail_id = id;
    this.findDetail(id);
  },
  methods: {
    cancelAppoint() {
      let context = this;
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要取消预约吗"
        })
        .then(() => {
          // 取消预约
          context.$API
            .post("/reserves/cancel", {
              id: context.detail_id
            })
            .then(data => {
              if (data.code == 0) {
                context.$toast("取消预约成功!");
                window.location.reload();
              } else {
                context.$toast(data.msg);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    findDetail(id) {
      this.$API.get(`/reserves/${id}`).then(data => {
        this.detail = data.data;

        var yy_date = dayjs(this.detail.reDate).format("YYYY-MM-DD");

        var week = new Date(Date.parse(yy_date.replace(/\-/g, "/"))).getDay();

        this.yy_date = yy_date + " " + this.getWeek(week);
      });
    },
    getWeek(day) {
      let week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return week[day];
    },
    chooseRecord() {
      this.record_show = true;
    },
    // 预约记录
    onRecordChange(value) {
      let reg = /\d/gi;
      let id = value.match(reg)[0];
      this.appoint_record = value;

      this.detail_id = this.records[id - 1].id;

      this.findDetail(this.detail_id);

      this.record_show = false;
    },
    getAppointRecords() {
      this.$API
        .get("/reserves", {
          openid: localStorage.openid,
          page: 1,
          limit: 5,
          time: new Date().getTime()
        })
        .then(data => {
          // this.record_show = true;
          this.records = data.data.list;
          this.recordColumns = (data.data.list || []).map(
            (_, index) => `第${index + 1}次`
          );
        });
    }
  }
};
</script>

<style scoped></style>
